import ToggleButtonGroup, {
  ToggleOption,
} from '../../../../components/Forms/Buttons/ToggleButtonGroup';
import SearchInputField from '../../../../components/Forms/Input/SearchInputField';
import SelectField from '../../../../components/Forms/Input/SelectField';

export type RecipeActiveFilter = 'ALL' | 'ACTIVE' | 'INACTIVE';

interface RecipeMenuItemOption {
  id: number;
  displayName?: string | null;
  productName?: string | null;
}

interface RecipeCategoryOption {
  id: number;
  name: string;
}

interface RecipeFiltersProps {
  search: string;
  categoryId: number;
  menuItemId: number;
  activeFilter: RecipeActiveFilter;
  menuItems: RecipeMenuItemOption[];
  categories: RecipeCategoryOption[];
  onSearchChange: (value: string) => void;
  onCategoryChange: (categoryId: number) => void;
  onMenuItemChange: (menuItemId: number) => void;
  onActiveChange: (activeFilter: RecipeActiveFilter) => void;
}

const activeOptions = [
  { value: 'ALL', label: 'Todas' },
  { value: 'ACTIVE', label: 'Activas' },
  { value: 'INACTIVE', label: 'Inactivas' },
] satisfies ToggleOption<RecipeActiveFilter>[];

const RecipeFilters = ({
  search,
  categoryId,
  menuItemId,
  activeFilter,
  menuItems,
  categories,
  onSearchChange,
  onCategoryChange,
  onMenuItemChange,
  onActiveChange,
}: RecipeFiltersProps) => (
  <div className="grid grid-cols-1 gap-4 border-b border-stroke bg-gray-2/40 p-5 dark:border-strokedark dark:bg-boxdark-2/30 md:grid-cols-2 xl:grid-cols-[minmax(240px,1fr)_minmax(190px,260px)_minmax(220px,300px)_auto] xl:items-end">
    <div className="xl:pb-5">
      <SearchInputField
        label="Buscar"
        name="recipeSearch"
        value={search}
        iconKey="search"
        placeholder="Receta, producto o código..."
        withMargin={false}
        onChange={(event) => onSearchChange(event.target.value)}
      />
    </div>

    <SelectField
      label="Categoría"
      name="recipeCategoryFilter"
      value={categoryId}
      iconKey="category"
      options={[
        { value: 0, label: 'Todas las categorías' },
        ...categories.map((category) => ({ value: category.id, label: category.name })),
      ]}
      onChange={(event) => onCategoryChange(Number(event.target.value))}
    />

    <SelectField
      label="Ítem de menú"
      name="recipeMenuItemFilter"
      value={menuItemId}
      iconKey="product"
      options={[
        {
          value: 0,
          label: 'Todos los ítems',
        },
        ...menuItems.map((item) => ({
          value: item.id,
          label:
            item.displayName ||
            item.productName ||
            `Ítem #${item.id}`,
        })),
      ]}
      onChange={(event) =>
        onMenuItemChange(Number(event.target.value))
      }
    />

    <ToggleButtonGroup
      value={activeFilter}
      options={activeOptions}
      onChange={onActiveChange}
      className="mb-5"
    />
  </div>
);

export default RecipeFilters;
